import type { TemplateFormLanguage } from '../types/templateForms';
import { DEFAULT_TEMPLATE_FORM_LANGUAGE } from './constants';

export interface ButtonTranslations {
    saveAndReturnLater: string;
    back: string;
    next: string;
    submit: string;
    addRow: string;
    alerts: {
        retainersNotSigned: string;
        draftSaveRequirements: string;
    };
}

const ENGLISH_TRANSLATIONS: ButtonTranslations = {
    saveAndReturnLater: 'Save and return later',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    addRow: 'Add Row',
    alerts: {
        retainersNotSigned:
            'You can submit the intake form only when all the users have signed the document.',
        draftSaveRequirements:
            'You must fill First Name, Last Name and Email to save the form as draft.',
    },
};

const FRENCH_TRANSLATIONS: ButtonTranslations = {
    saveAndReturnLater: 'Enregistrer et revenir plus tard',
    back: 'Retour',
    next: 'Suivant',
    submit: 'Soumettre',
    addRow: 'Ajouter une ligne',
    alerts: {
        retainersNotSigned:
            'Vous ne pouvez soumettre le formulaire d’admission que lorsque tous les signataires ont signé le document.',
        draftSaveRequirements:
            'Vous devez indiquer le prénom, le nom de famille et le courriel pour enregistrer le formulaire comme brouillon.',
    },
};

export const BUTTON_TRANSLATIONS: Record<TemplateFormLanguage, ButtonTranslations> = {
    en: ENGLISH_TRANSLATIONS,
    fr: FRENCH_TRANSLATIONS,
};

export function getButtonTranslations(
    language: TemplateFormLanguage = DEFAULT_TEMPLATE_FORM_LANGUAGE,
): ButtonTranslations {
    return BUTTON_TRANSLATIONS[language] ?? BUTTON_TRANSLATIONS.en;
}
